function throttle(fn, timeout = 500) {
    let running;
    let result;
    return (...args) => {
        if (!running) {
            running = true;
            setTimeout(() => {
                running = false;
            }, timeout);
            result = fn(...args);
        }
        return result;
    };
}

function debounce(cb, ms) {
    let timeout;
    return function (...args) {
        if (timeout)
            clearTimeout(timeout);
        timeout = window.setTimeout(() => cb.apply(this, args), ms);
    };
}

const isServer = typeof window === 'undefined';
const isTruthy = (n) => n !== undefined && n !== null && n !== false;
const isExists = (n) => n !== undefined && n !== null;
const isUndefined = (n) => n === undefined;
const isArray = (n) => Array.isArray(n);
const isBoolean = (n) => typeof n === 'boolean';
const isNumber = (n) => typeof n === 'number' && !Number.isNaN(n);
const isFunction = (f) => typeof f === 'function';
const isString = (str) => Object.prototype.toString.call(str) === '[object String]';
const isPrimitive = (n) => isString(n) || isNumber(n) || isBoolean(n) || isUndefined(n);
const isObject = (n) => isExists(n) && !isArray(n) && typeof n === 'object';
const isEmptyObject = (n) => isExists(n) &&
    !isArray(n) &&
    Object.entries(n).length === 0 &&
    n.constructor === Object;
const is = {
    server: isServer,
    truthy: isTruthy,
    exists: isExists,
    undefined: isUndefined,
    boolean: isBoolean,
    array: isArray,
    number: isNumber,
    string: isString,
    primitive: isPrimitive,
    function: isFunction,
    object: isObject,
    emptyObject: isEmptyObject,
};

export { debounce, is, isArray, isBoolean, isEmptyObject, isExists, isFunction, isNumber, isObject, isPrimitive, isServer, isString, isTruthy, isUndefined, throttle };
//# sourceMappingURL=index.js.map
